import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  Box,
  styled,
  Typography,
  Button,
  TextField,
  FormHelperText,
  MenuItem,
  CircularProgress,
} from "@mui/material";

const CustomTextarea = styled(TextField)(() => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    backgroundColor: "transparent",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    color: "black",
    padding: "10px 15px",
    "&:hover": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
    },
    "&.Mui-focused": {
      backgroundColor: "transparent",
      border: "1px solid #e5e7eb",
      outline: "none",
    },
  },

  "& .MuiInputBase-input": {
    padding: "0",
  },

  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
    "&:hover": {
      border: "none",
    },
  },
}));

const BannerForm = ({ formik, edited }) => {
  const [categories, setCategories] = useState([])
  const goalCategories = useSelector((state) => state.goalCategories);
  const bannersCategories = useSelector((state) => state.bannersCategories);

  // "";

  useEffect(() => {
    if (bannersCategories.data?.data?.length) {
      setCategories(bannersCategories.data.data)
    }
  }, [bannersCategories])

  return (
    <Box className="page_inner">
      <form onSubmit={formik.handleSubmit}>
        <Box className="create-banner-form professional-tournament-form">
          <Box className="category form-control">
            <Typography className="label">Link</Typography>
            <CustomTextarea
              variant="outlined"
              name="link"
              value={formik.values.link}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter Youtube Link"
            />
            {formik.touched.link && formik.errors.link ? (
              <FormHelperText sx={{ color: "red" }}>
                {formik.errors.link}
              </FormHelperText>
            ) : (
              ""
            )}
          </Box>

          <Box className="category form-control">
            <Box className="category_field">
              <Typography className="label">Category</Typography>
              <CustomTextarea
                select
                variant="outlined"
                name="category"
                value={formik.values.category}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <MenuItem value="default">Select an Category</MenuItem>
                {bannersCategories.loading ? (
                  <CircularProgress sx={{ color: "#ef364e" }} />
                ) : categories.length > 0 ? (
                  categories.map((category) => (
                    ![6, 7].includes(category.id) && <MenuItem value={category.id}>{category.name}</MenuItem>
                  ))
                ) : (
                  bannersCategories.error
                )}
              </CustomTextarea>
              {formik.touched.category && formik.errors.category ? (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.category}
                </FormHelperText>
              ) : (
                ""
              )}
            </Box>
          </Box>

          <Box className="category form-control">
            <Button className="pt-create" type="submit">
              {edited ? "Update" : "Add"}
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );
};

export default BannerForm;
